import { actions, mutations } from "@/store";
import { get, post, put } from "@/utils/api";
import { trackException } from "@/appInsights";
import { AppNotification } from "@/constants/appNotification";

export default {
  async getComplianceReviewList({ dispatch, commit }, payload) {
    commit(mutations.getComplianceReviewListInit);
    const url = `${process.env.VUE_APP_ARBITRIUM_API}/v1/compliance-reviews/filter?limit=1000&offset=0&orderBy=createdUtc&orderDirection=desc`;

    try {
      const data = await post(url, payload);

      commit(mutations.getComplianceReviewListSuccess, {
        data
      });
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/complianceReviews/getComplianceReviewList" }
      });
      commit(mutations.getComplianceReviewListError, {
        error: error.message
      });
      dispatch(actions.notificationAdd, {
        id: AppNotification.GetComplianceReviewListError,
        title: "Getting compliance reviews list failed",
        message: `Getting compliance reviews list failed with error: "${error.message}"`,
        duration: 0,
        actions: [{ label: "Dismiss" }]
      });
    }
  },

  async getComplianceReviewItem({ dispatch, commit }, { id }) {
    commit(mutations.getComplianceReviewItemInit);
    const url = `${process.env.VUE_APP_ARBITRIUM_API}/v1/compliance-reviews/${id}`;

    try {
      const data = await get(url);

      commit(mutations.getComplianceReviewItemSuccess, {
        data
      });
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/complianceReviews/getComplianceReviewItem" }
      });
      commit(mutations.getComplianceReviewItemError, {
        error: error.message
      });
      dispatch(actions.notificationAdd, {
        id: AppNotification.GetComplianceReviewItemError,
        title: "Getting compliance reviews item failed",
        message: `Getting compliance review item with id ${id} failed with error: "${error.message}"`,
        duration: 0,
        actions: [{ label: "Dismiss" }]
      });
    }
  },

  async putResolveComplianceReview({ dispatch, commit }, { id, payload }) {
    commit(mutations.putResolveComplianceReviewInit);
    const url = `${process.env.VUE_APP_ARBITRIUM_API}/v1/compliance-reviews/${id}/resolve`;

    try {
      await put(url, payload);
      commit(mutations.putResolveComplianceReviewSuccess);

      dispatch(actions.notificationAdd, {
        id: AppNotification.ComplianceReviewPutSuccess,
        title: "Success!",
        message: "Compliance review was resolved successfully"
      });
    } catch (error) {
      trackException({
        exception: error,
        properties: { source: "store/complianceReviews/putResolveComplianceReview" }
      });
      commit(mutations.putResolveComplianceReviewError, {
        id,
        error: error.message
      });
      dispatch(actions.notificationAdd, {
        id: AppNotification.ComplianceReviewPutError,
        title: "Failed to resolve compliance review",
        message: error.message
      });
    }
  }
};
